import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { VerticalMenuItem } from '../../models/vertical-menu/vertical-menu-item';

@Component({
    selector: 'app-vertical-menu',
    templateUrl: './vertical-menu.component.html',
    styleUrls: ['./vertical-menu.component.scss'],
    standalone: false
})
export class VerticalMenuComponent implements OnInit {

  @Input() menuItems: VerticalMenuItem[];
  @Output() selected = new EventEmitter<VerticalMenuItem>();
  menuObj: any = {};


  constructor() { }

  ngOnInit(): void {
    this.menuObj = {};
    if(this.menuItems) {
      setTimeout(() => {
        for (const item of this.menuItems) {
          if (item.selected) {
            this.menuItemClick(item);
          }
        }
      }, 1000);
    }
  }

  public menuItemClick(menuItem?: VerticalMenuItem): void {
    if (menuItem.items?.length) {
      menuItem.expanded = !menuItem.expanded;
    } else {
      this.menuItems.forEach(item => this.deselectMenuItem(item));
      menuItem.selected = true;
      this.selected.emit(menuItem);
      if (menuItem.onSelected) {
        menuItem.onSelected(menuItem);
      }
    }
  }

  private deselectMenuItem(menuItem: VerticalMenuItem): void {
    menuItem.selected = false;
    if (menuItem.items) {
      menuItem.items.forEach(item => this.deselectMenuItem(item));
    }
  }
}
